import React, { ChangeEvent } from "react";

interface CommentBoxProps {
  value: string;
  disabled?: boolean;
  onChange: (val: string) => void;
  placeholder?: string;
}

const CommentBox: React.FC<CommentBoxProps> = ({ value, disabled, onChange, placeholder }) => {
  return (
    <textarea
      style={{
        width: "100%",
        height: "100%",
        resize: "none",
        border: "#B1B1C5 solid 1px",
        padding: "1%",
      }}
      name="comment"
      id="comment"
      placeholder={placeholder || "Kommentar hinzufügen"}
      value={value}
      onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
      disabled={disabled}
    />
  );
};

export default CommentBox;
